import { Injectable, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { Observable, Observer } from "rxjs/Rx";
import { map, catchError } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { finalize } from "rxjs/operators";
import { Router, UrlSerializer } from "@angular/router";
import { ModalDefinirContaComponent } from "../components/modal-definir-conta/modal-definir-conta.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { throwError } from "rxjs";
import { isPlatformBrowser } from "@angular/common";

import { IParametrosBackEnd } from "../interfaces/IParametrosBackEnd";

declare var window: any;
declare var FB: any;

export type MetodoLogin = "email" | "google" | "linkedin" | "microsoft";

const METODOS_LOGIN: MetodoLogin[] = ["email", "google", "linkedin", "microsoft"];

// Os apps de login de empresa e de candidato rodam no mesmo domínio e compartilham este cookie.
const CHAVE_ULTIMO_LOGIN = "reachr_ultimo_login";
const COOKIE_ULTIMO_LOGIN_MAX_AGE = 60 * 60 * 24 * 365;

@Injectable({
  providedIn: "root",
})
export class AuthService implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private serializer: UrlSerializer,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {}

  ngOnInit() {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }

  /** Guarda o método do último login bem-sucedido para destacá-lo na tela de login. */
  registrarUltimoLogin(metodo: MetodoLogin) {
    try {
      document.cookie = `${CHAVE_ULTIMO_LOGIN}=${metodo}; path=/; max-age=${COOKIE_ULTIMO_LOGIN_MAX_AGE}; SameSite=Lax`;
    } catch (e) {}
  }

  ultimoLogin(): MetodoLogin | null {
    try {
      const valor = document.cookie
        .split("; ")
        .find((c) => c.startsWith(`${CHAVE_ULTIMO_LOGIN}=`))
        ?.split("=")[1];
      return METODOS_LOGIN.includes(valor as MetodoLogin) ? (valor as MetodoLogin) : null;
    } catch (e) {
      return null;
    }
  }

  loginAzure(url) {
    const httpParams = new HttpParams({ fromString: url.split("?")[1] });
    let code = httpParams.get("azureCode");
    let empresaId = httpParams.get("emp");

    var registerData = {
      provider: "Azure",
      externalAccessToken: code,
      empresaId: empresaId,
    };

    const parametros: IParametrosBackEnd =
      this.getParametrosBackEndFromLocalStorageAndDelete();
    console.log(parametros);
    this.registerExternal(registerData).subscribe(
      (response) => {
        this.registrarUltimoLogin("microsoft");
        this.redirecionarUsuarioAposChecarPermissoes(
          response,
          response.userName,
          parametros
        );
      },
      (error) => {
        console.log(error);
        
        if (error.Message == "Usuário não cadastrado") {
          alert("Nenhuma conta de empresa foi cadastrada na plataforma com o seu e-mail!")
        }
      }
    );
  }

  loginLinkedin(url) {
    console.log('[LinkedIn] loginLinkedin chamado. URL:', url);
    const httpParams = new HttpParams({ fromString: url.split("?")[1] });
    let code = httpParams.get("code");
    console.log('[LinkedIn] code extraído:', code ? code.substring(0, 20) + '...' : 'NULL');
    let state = httpParams.get("state");
    let error = httpParams.get("error");
    let error_description = httpParams.get("error_description");
    let urlVagaId = httpParams.get("vagaId");

    // vagaId pode vir no state codificado como "<random>|<vagaId>"
    if (!urlVagaId && state && state.includes('|')) {
      urlVagaId = state.split('|')[1];
    }

    var registerData = {
      provider: "Linkedin",
      externalAccessToken: code,
    };

    let parametros: IParametrosBackEnd =
      this.getParametrosBackEndFromLocalStorageAndDelete();

    // vagaId da URL tem prioridade sobre o localStorage
    if (urlVagaId) {
      parametros = parametros ?? { vagaId: '', redirect: '', origem: 'reachr', midiaCampanha: '', nomeCampanha: '' };
      parametros.vagaId = urlVagaId;
    }

    console.log('[LinkedIn] parametros finais:', parametros);
    this.registerExternal(registerData).subscribe(
      (response) => {
        this.registrarUltimoLogin("linkedin");
        this.redirecionarUsuarioAposChecarPermissoes(
          response,
          response.userName,
          parametros
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  registerExternal(registerData): Observable<any> {
    return this.http
      .post(environment.serverApi + "/account/registerexternal", registerData)
      .pipe(
        map((res) => res),
        catchError((error) => throwError(error.error || "Server error"))
      );
  }

  login(data, parametros): Observable<string> {
    var dataUser =
      "grant_type=password&username=" +
      data.userName +
      "&password=" +
      data.password;

    return this.http.post(environment.serverToken, dataUser).pipe(
      map((response) => {
        // console.log(response);
        // console.log(data.userName);
        // console.log(parametros);
        this.registrarUltimoLogin("email");
        return this.redirecionarUsuarioAposChecarPermissoes(
          response,
          data.userName,
          parametros
        );
      }),
      catchError((error) => {
        console.log(error);
        return throwError(error);
      })
    );
  }

  getUrlRedirect(response, userName, parametros) {
    console.log("gur", parametros);
    let item = {
      token: response.access_token,
      name: response.name,
      userName: userName,
      refreshToken: "",
      useRefreshTokens: false,
      photoNormal: response.photoNormal,
      photoThumb: response.photoThumb,
      perfil: response.perfil,
      permissoes: response.permissoes ? response.permissoes : [],
      empresas: response.empresas ? response.empresas : [],
      socialNetwork: response.socialNetwork,
      whiteLabel: response.whiteLabel,
    };
    localStorage.setItem("ls.authorizationData", JSON.stringify(item));
    let permissoes = JSON.parse(item.permissoes);
    //console.log(permissoes);
    //console.log(response);

    let sessionPermissoes = sessionStorage.getItem("linkedin-redirect");
    if (sessionPermissoes != null && permissoes.length == 0) {
      if (sessionPermissoes == "candidato" || sessionPermissoes == "empresa") {
        permissoes.push(sessionPermissoes);
      }
    }
    //console.log(permissoes);
    var url = "/candidato/#/perfil/cadastro";

    for (var i = 0; i < permissoes.length; i++) {
      //console.log('p', permissoes[i], parametros);
      if (permissoes[i] == "candidato") {
        url = this.getUrlCandidato(parametros);
      }
      if (permissoes[i] == "empresa") {
        var novaDash = permissoes.findIndex(
          (res) => res.toLowerCase() == "novodashboard"
        );
        url = "/empresas/#/dashboard";

        // if (novaDash != -1) {
        //   url = "/empresas/#/dashboard";
        // } else {
        //   if (parametros != null && parametros.redirect) {
        //     url = parametros.redirect;
        //   } else {
        //     const empresasLimpo = item.empresas.replace(/[\[\]"]+/g, "").trim();

        //       url = "/empresas/#/dashboard";

        //   }
        // }
      }
    }
    return this.urlDoSite() + url;
  }

  /**
   * O site responde em reachr.com.br e em www.reachr.com.br, e o token fica no localStorage
   * de quem fez o login. Redireciona para o mesmo domínio para a dashboard encontrar o token.
   */
  urlDoSite(): string {
    if (isPlatformBrowser(this.platformId) && /(^|\.)reachr\.com\.br$/.test(window.location.hostname)) {
      return window.location.origin;
    }
    return environment.serverUrl;
  }

  getUrlCandidato(parametros) {
    if (parametros && parametros.vagaId != undefined) {
      if (parametros.redirect && parametros.vagaId) {
        if (parametros.redirect == "provas-especificas") {
          const tree = this.router.createUrlTree([""], {
            queryParams: {
              vagaId: parametros.vagaId ? parametros.vagaId : "",
              redirect: parametros.redirect ? parametros.redirect : "",
              origem: parametros.origem ? parametros.origem : "",
              midiaCampanha: parametros.midiaCampanha
                ? parametros.midiaCampanha
                : "",
              nomeCampanha: parametros.nomeCampanha
                ? parametros.nomeCampanha
                : "",
            },
          });
          return (
            "/candidato/#/perfil/cadastro/prova-especifica" +
            this.serializer.serialize(tree)
          );
        } else if (parametros.redirect == "solicitar-documentos") {
          const tree = this.router.createUrlTree([""], {
            queryParams: {
              vagaId: parametros.vagaId ? parametros.vagaId : "",
              redirect: parametros.redirect ? parametros.redirect : "",
              origem: parametros.origem ? parametros.origem : "",
              midiaCampanha: parametros.midiaCampanha
                ? parametros.midiaCampanha
                : "",
              nomeCampanha: parametros.nomeCampanha
                ? parametros.nomeCampanha
                : "",
            },
          });
          return (
            "/candidato/#/perfil/cadastro/documentacao" +
            this.serializer.serialize(tree)
          );
        } else if (!parametros.redirect && parametros.vagaId) {
          return parametros.redirect;
        }
      } else if (parametros.redirect == "solicitar-questionario") {
        return (
          "/candidato/#/vagas/" + parametros.vagaId + "?visualizar=candidatura"
        );
      } else {
        const tree = this.router.createUrlTree([""], {
          queryParams: {
            vagaId: parametros.vagaId ? parametros.vagaId : "",
            redirect: parametros.redirect ? parametros.redirect : "",
            origem: parametros.origem ? parametros.origem : "",
            midiaCampanha: parametros.midiaCampanha
              ? parametros.midiaCampanha
              : "",
            nomeCampanha: parametros.nomeCampanha
              ? parametros.nomeCampanha
              : "",
          },
        });
        return "/candidato/#/perfil/cadastro" + this.serializer.serialize(tree);
      }
    }
    return "/candidato/#/dashboard";
  }

  initFacebook() {
    // BROWSER
    if (isPlatformBrowser(this.platformId)) {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/pt_BR/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");

      window.fbAsyncInit = () => {
        FB.init({
          appId: environment.facebookId,
          autoLogAppEvents: true,
          xfbml: true,
          version: "v3.3",
        });

        FB.AppEvents.logPageView();
        FB.Event.subscribe("auth.statusChange", (response) => {
          if (response.status === "connected") {
          }
        });
      };
    }
  }

  loginFacebook(parametros: IParametrosBackEnd) {
    FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        this.redirectAfterLogin(response, parametros);
      } else {
        FB.login(
          (loginResponse) => {
            this.redirectAfterLogin(loginResponse, parametros);
          },
          { scope: "public_profile,email" }
        );
      }
    });
  }

  redirectAfterLogin(response, parametros: IParametrosBackEnd) {
    var registerData = {
      provider: "Facebook",
      UserName: response.authResponse.userID,
      externalAccessToken: response.authResponse.accessToken,
    };

    this.registerExternal(registerData).subscribe(
      (response) => {
        this.redirecionarUsuarioAposChecarPermissoes(
          response,
          response.userName,
          parametros
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  criarConta(user): Observable<string> {
    let data = {
      Nome: user.Nome,
      Name: user.Nome,
      Telefone: user.Telefone,
      Password: user.Password,
      ConfirmPassword: user.Password,
      Username: user.Email,
      Email: user.Email,
      UserName: user.Email,
      TermosDeUso: true,
      WhiteLabel: "Site Principal",
      Empresa: "",
      Gender: "",
      EmailConfirmed: true,
      Cargo: "",
    };

    return this.http
      .post(
        environment.serverApi + "/account/register?EmailConfirmed=true",
        data
      )
      .pipe(
        map((response) => {
          let dataLogin = {
            userName: data.Username,
            password: data.Password,
          };

          return "ok";
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  uploadCVCadastro(curriculo): Observable<string> {
    var fd = new FormData();
    fd.append("upload", curriculo);

    var authorizationData = JSON.parse(
      localStorage.getItem("ls.authorizationData")
    );
    const headers = new HttpHeaders({
      Authorization: "Bearer " + authorizationData.token,
    });

    return this.http
      .post(environment.serverUrl + "/api/upload/UploadCV", fd, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return "ok";
        }),
        catchError((error) => {
          console.log(error);
          return throwError(error.error || "Server error");
        })
      );
  }

  private getParametrosBackEndFromLocalStorageAndDelete(): IParametrosBackEnd {
    const parametros = localStorage.getItem("parametros-vaga-login-linkedin");
    if (parametros != "undefined") {
      localStorage.removeItem("parametros-vaga-login-linkedin");
      return JSON.parse(parametros);
    }
    return null;
  }

  redirecionarUsuarioAposChecarPermissoes(response, userName, parametros) {
    let string = response.permissoes ? response.permissoes : [];
    let permissoes = JSON.parse(string);

    let sessionPermissoes = sessionStorage.getItem("linkedin-redirect");
    if (sessionPermissoes != null && permissoes.length == 0) {
      if (sessionPermissoes == "candidato" || sessionPermissoes == "empresa") {
        permissoes.push(sessionPermissoes);
      }
    }
    //console.log(permissoes);
    //console.log(parametros);

    if (permissoes.length == 0) {
      // temos dados da vaga?
      if (!parametros) {
        let modalOption: NgbModalOptions = {
          backdrop: "static",
          keyboard: false,
        };

        let tipoConta = "candidato";

        // let modalRef = this.modalService.open(
        //   ModalDefinirContaComponent,
        //   modalOption
        // );

        response.permissoes = JSON.stringify([tipoConta]);
        let url = this.getUrlRedirect(response, userName, parametros);
        window.location.href = url;
        localStorage.setItem("permissoes", JSON.stringify(response.permissoes));
        console.log(response.permissoes, url);
        return url;

        // modalRef.componentInstance.contaEscolhida.subscribe(($conta) => {
        //   console.log($conta);
        //   if ($conta) {
        //     let url = this.getUrlRedirect(response, userName, parametros);

        //     response.permissoes = JSON.stringify([$conta]);
        //     window.location.href = url;

        //     return url;

        //     //console.log(url);
        //   }
        // });
      } else {
        response.permissoes = JSON.stringify(["candidato"]);

        let url = this.getUrlRedirect(response, userName, parametros);
        //console.log(url);
        window.location.href = url;
        return url;
      }
    } else {
      let url = this.getUrlRedirect(response, userName, parametros);
      //console.log(url);
      window.location.href = url;
      return url;
    }
  }
}
